import * as React from 'react'
import { SFC } from 'react'

export const SpreadBody: SFC<{ greyBg?: boolean, xl?: boolean, top?: number, bottom?: number }> =
    ({greyBg, xl, children, top, bottom}) => (
        <div style={{background: greyBg ? '#f7f7f7' : '#fff'}}>
            <div style={{maxWidth: xl ? 1000 : 900, margin: 'auto'}}>
                <div style={{paddingTop: top || 60, paddingBottom: bottom || 60}}>
                    {children}
                </div>
            </div>
        </div>
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/SpreadBody.tsx